import axios from 'axios';
import { refreshAccessToken, forceReLogin } from './tokenSession';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': true,
  }
});

instance.interceptors.request.use(
  config => {
      const accessToken = localStorage.getItem('access-token');
      if (accessToken) {
          config.headers['Authorization'] = `Bearer ${accessToken}`;
          config.headers.common = { Authorization: `Bearer ${accessToken}` };
      }
      return config;
  },

    error => Promise.reject(error.response || error.message)
);

instance.interceptors.response.use(
  response => response,
  async error => {
      const status = error.response?.status;
      const originalRequest = error.config || {};

      if (status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;

          // Try to silently swap a fresh access token in and retry the
          // original request. Only when that fails (or there is no
          // refresh-token to begin with) do we drag the user back to /login.
          try {
              const newToken = await refreshAccessToken();
              originalRequest.headers = originalRequest.headers || {};
              originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
              return instance(originalRequest);
          } catch (_) {
              forceReLogin();
              return Promise.reject(error.response || error.message);
          }
      }

      // Requests can opt out of the global 403 redirect to handle it inline.
      if (status === 403 && !originalRequest.skipForbiddenRedirect) {
        window.location.href = '/403';
      }

      return Promise.reject(error.response || error.message);
  }
);

export default instance;
